<template>
    <div class="capacity__ad text-center" :class="className" v-tooltip="{ content: tooltip, classes: 'tooltip-wide' }">
        {{ usedCapacity }}
    </div>
</template>

<script>
    export default {
        props: ['cell'],

        computed: {
            className() {
                if (this.usedCapacity > 0) {
                    return 'capacity__ad-booked'
                }
            },

            usedCapacity() {
                return this.cell.ads.reduce((sum, ad) => sum + ad.publication_based_ad_format.size, 0)
            },

            tooltip() {
                return this.cell.ads.map(ad => {
                    return ad.order.company.name + ' (' + ad.publication_based_ad_format.name + ')'
                }).join('<br>')
            }
        }
    }
</script>
